const IconPlay = () => {
  return (
    <path
      d="M-0.000176667 25.0938V2.75C-0.000176667 1.82292 0.239407 1.13542 0.718573 0.687501C1.19774 0.229168 1.76545 1.50222e-06 2.4217 1.50222e-06C3.00503 1.50222e-06 3.58316 0.166668 4.15607 0.500001L22.8123 11.375C23.4998 11.7813 23.9998 12.1719 24.3123 12.5469C24.6352 12.9219 24.7967 13.3802 24.7967 13.9219C24.7967 14.4531 24.6352 14.9115 24.3123 15.2969C23.9998 15.6719 23.4998 16.0573 22.8123 16.4531L4.15607 27.3437C3.58316 27.6771 3.00503 27.8437 2.4217 27.8437C1.76545 27.8437 1.19774 27.6146 0.718573 27.1562C0.239407 26.6979 -0.000176667 26.0104 -0.000176667 25.0938Z"
      fill="currentColor"
      data-testid="icon-play"
    />
  );
};

export default IconPlay;
